var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKlevuLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 182,
    height: 27,
    viewBox: "0 0 182 27",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_893_7694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.6136 0.979061V11.8176H43.3932L56.8413 0.979061H62.1036L46.5506 12.7729L63.5849 26.1099H58.2836L42.6136 13.7282V26.1099H39.1055V0.979061H42.6136Z",
    fill: "#0A4563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.731 26.1099V0.979061H72.2781V23.3176H89.7019V26.1099H68.731Z",
    fill: "#0A4563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.052 0.979061V3.51419H98.3554V11.634H114.689V14.1691H101.864L98.3554 12.2953V23.3176H116.052V26.1099H94.8086V0.979061H116.052Z",
    fill: "#0A4563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.126 0.942471V18.174C159.126 19.6069 159.71 20.8193 160.88 21.8114C162.049 22.8033 163.491 23.3178 165.129 23.3178H171.794C173.47 23.3178 174.912 22.8033 176.081 21.8114C177.251 20.8193 177.836 19.6069 177.836 18.174V0.942471H181.344V18.7619C181.266 20.8193 180.408 22.5462 178.771 23.9791C177.134 25.412 175.147 26.11 172.73 26.11H164.193C161.815 26.11 159.788 25.412 158.073 23.9791C156.397 22.5462 155.578 20.8193 155.578 18.7619V0.942471H159.126Z",
    fill: "#0A4563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.29515 24.3098C0.944327 24.8242 1.06126 25.559 1.60698 25.9265C2.19168 26.2938 2.93231 26.1469 3.32211 25.6325L12.4045 13.2508L21.4479 25.6325C21.8376 26.1469 22.6173 26.2938 23.1629 25.9265C23.7087 25.559 23.8646 24.8609 23.4748 24.3098L13.4179 10.5319L12.4045 9.13583L11.3909 10.5319L1.29515 24.3098Z",
    fill: "#97C73E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25755 12.075C3.90672 12.5894 4.02367 13.3242 4.56939 13.6916C5.11511 14.059 5.89471 13.912 6.28451 13.3977L12.4044 5.05746L18.4853 13.3609C18.8751 13.9488 19.6937 14.059 20.2393 13.6916C20.7851 13.3242 20.902 12.5894 20.5123 12.075L13.4178 2.33862L12.4044 0.942471L11.3909 2.33862L4.25755 12.075Z",
    fill: "#97C73E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.925 0.942471L136.01 23.0605L125.135 0.942471H121.237L133.594 26.11H138.427L150.822 0.942471H146.925Z",
    fill: "#0A4563"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_893_7694"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 181,
    height: 26,
    fill: "white",
    transform: "translate(0.75 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlevuLogo);
export default __webpack_public_path__ + "static/media/klevu-logo.5446ac3617830cdbe64256b347f89e5f.svg";
export { ForwardRef as ReactComponent };